import { render, staticRenderFns } from "./HomePageTasks.vue?vue&type=template&id=212a1f79&scoped=true"
import script from "./HomePageTasks.vue?vue&type=script&lang=js"
export * from "./HomePageTasks.vue?vue&type=script&lang=js"
import style0 from "./HomePageTasks.vue?vue&type=style&index=0&id=212a1f79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a1f79",
  null
  
)

export default component.exports